module.exports = __webpack_public_path__ + "static/media/18ECA19.9fa69889.jpg";